import { legacyFeApi } from './legacyFeApi';

export type LegacyApiTagTypes = 'legacyApi';

export const enhancedLegacyFeApi = legacyFeApi.enhanceEndpoints<LegacyApiTagTypes>({
  addTagTypes: [],
  endpoints: {},
});
